import { useDocItemsContext } from './useDocItemsContext';

export function useDocItems() {
  const docs = useDocItemsContext((s) => s.docs);
  const children = useDocItemsContext((s) => s.childrenMap);
  const docsMap = useDocItemsContext((s) => s.docsMap);
  const isDocsLoading = useDocItemsContext((s) => s.isDocsLoading);

  return { docs, children, docsMap, isDocsLoading };
}
